// Metodo di pagamento = come ha pagato il cliente. La banca (rapporto di incasso) e' un altro campo:
// dove arrivano i soldi. Il metodo suggerisce la banca, mai il contrario.
export const METODI_PAGAMENTO = [
  { value: 'contanti', label: 'Contanti', banca: 'CONTANTI' },
  { value: 'pos', label: 'Carta / POS', banca: 'MY POS' },
  { value: 'bonifico', label: 'Bonifico', banca: null },
  { value: 'contrassegno', label: 'Contrassegno', banca: 'MC - TRANSITO CONTRASSEGNI' },
  { value: 'paypal', label: 'PayPal (online)', banca: 'PAYPAL' },
  { value: 'sumup', label: 'Carta online (SumUp)', banca: 'SUMUP' },
  { value: 'marketplace', label: 'Marketplace', banca: 'MC - TRANSITO IBS' },
];

// Solo storico: non si scelgono piu' (Stripe e Google Pay via Stripe non sono piu' offerti sul sito)
const METODI_STORICI = { stripe: 'Stripe (storico)', google_pay: 'Google Pay (storico)' };

export const labelMetodoPagamento = (value) => {
  if (!value) return '';
  const trovato = METODI_PAGAMENTO.find((m) => m.value === value);
  return trovato ? trovato.label : (METODI_STORICI[value] || value);
};

// Banca suggerita dal metodo (o undefined se non ce n'e' una o non esiste tra quelle disponibili)
export const bancaSuggerita = (metodo, banche) => {
  const m = METODI_PAGAMENTO.find((x) => x.value === metodo);
  if (!m || !m.banca) return undefined;
  return (banche || []).find((b) => b.denominazione === m.banca);
};
